import type { ChatFeed } from "../chat/events.ts";

/**
 * Hands the party the chat feed's sender and frames (ADR-101 decision 19): the party's messages travel on the same
 * connection as chat's, and both the chat panel and the party store read them. The feed's other methods stay the
 * chat's.
 *
 * @param feed The chat panel's feed.
 * @param party The party store, which takes the sender and the frames.
 * @returns The feed to give the scene in the chat's place.
 * @example
 * partyingFeed(alertingFeed(chatStore, chatAlerts), partyStore);
 */
export function partyingFeed(feed: ChatFeed, party: Pick<ChatFeed, "bind" | "receive">): ChatFeed {
  return {
    bind: (send) => {
      feed.bind(send);
      party.bind(send);
    },
    receive: (event) => {
      feed.receive(event);
      party.receive(event);
    },
    note: (text) => feed.note(text),
    death: (text) => feed.death(text),
  };
}
